// extracted by mini-css-extract-plugin
module.exports = {"title":"IpoHero_title__WLCQU"};